(function () {
  'use strict';

  /* @ngdoc object
   * @name electronicLogBook
   * @description
   *
   */
  angular
    .module('crewScheduleChangeReport', [
      'ui.router'
    ]);
}());
